import { NgModule } from '@angular/core';
import { KpiService } from '@app/modules/finish-phase/state/kpi/kpi.service';
import { OrderPhaseService } from '@app/shared/components/order-phase/order-phase.service';
import { SharedModule } from '@app/shared/shared.module';
import { EndComponent } from './containers/end/end.component';
import { OverviewComponent } from './containers/overview/overview.component';
import { FinishPhaseComponent } from './finish-phase.component';
import { FinishPhaseService } from './services';
import { KpiQuery } from './state/kpi/kpi.query';
import { KpiStore } from './state/kpi/kpi.store';
import { DismountContainerModalComponent } from './containers/overview/components/dismount-container-modal';
import { ToolCheckoutComponent } from './containers/tool-checkout/tool-checkout.component';

@NgModule({
  declarations: [FinishPhaseComponent, OverviewComponent, EndComponent, DismountContainerModalComponent, ToolCheckoutComponent],
  imports: [SharedModule],
  providers: [OrderPhaseService, KpiService, KpiQuery, KpiStore, FinishPhaseService]
})
export class FinishPhaseModule {}
